<div class="confirmation-popup">
  <!-- <mat-dialog-content class="p-0 m-0 confirmation-popup__dialog-content"> -->
  <div>
    <div class="confirmation-popup__apiresponsediv activity-description-bold">
      <p class="confirmation-popup__message seat-alert-messages" *ngIf="!isScrolable" id="confirmationMsg"
        [innerHTML]="confirmationMessage"></p>
      <div class="confirmation-popup__message confirmation-popup_scrollable seat-alert-messages" *ngIf="isScrolable"
        id="confirmationMsg" [innerHTML]="confirmationMessage"></div>
    </div>
  </div>


</div>